import { EventInput } from "@fullcalendar/core";
import { addMinutes } from "date-fns";

import Activity from "@mapmycustomers/shared/types/entity/Activity";
import ActivitySuggestion from "@mapmycustomers/shared/types/entity/ActivitySuggestion";

import { formatDate } from "@app/util/formatters";
import isValidDate from "@app/util/isValidDate";
import { parseApiDate } from "@app/util/parsers";

import EventObject from "../type/EventObject";

const activityToEvent = (
  activity: Activity,
  nearbySuggestionsMap: Map<Activity["id"], ActivitySuggestion>
): EventInput => {
  const result: EventInput = {
    id: String(activity.id),
    allDay: activity.allDay,
    className: `act_${activity.id}`,
    editable: !activity.emailLogId && activity.accessStatus?.update !== false,
    end: activity.endAt ?? undefined,
    extendedProps: {
      activity,
    } as EventObject,
    groupId: String(activity.parentId ?? activity.id),
    start: activity.startAt ?? undefined,
    title: activity.name ?? activity.note,
  };

  // for allDay activity, let's ensure that end date is not defined and that start date
  // will be of a correct date, taking user's TZ into account
  if (activity.allDay) {
    const startAt = activity.startAt ? parseApiDate(activity.startAt) : undefined;
    result.start = isValidDate(startAt) ? formatDate(startAt, "yyyy-MM-dd") : undefined;
    result.end = undefined;
  }

  if (nearbySuggestionsMap.has(activity.id)) {
    result.extendedProps!.suggestion = nearbySuggestionsMap.get(activity.id);
  }

  // make email activity as small as possible, which doesn't happen if it has no end time
  if (activity.emailLogId) {
    const startAt = activity.startAt ? parseApiDate(activity.startAt) : undefined;
    result.end = isValidDate(startAt) ? addMinutes(startAt, 5).toISOString() : undefined;
  }

  return result;
};

export default activityToEvent;
